var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"tw-font-robotoBold tw-text-xs lg:tw-text-base tw-text-red-350 tw-px-4 tw-bg-pink-100 tw-rounded-xl"},[_vm._v(" "+_vm._s(_setup.props.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }